import { render, staticRenderFns } from "./WSlider.vue?vue&type=template&id=6705cfed&"
import script from "./WSlider.vue?vue&type=script&lang=js&"
export * from "./WSlider.vue?vue&type=script&lang=js&"
import style0 from "./WSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
